export default "__VITE_ASSET__BueUubwf__"